import styled from "styled-components";
export const DeletedFilesStyle = styled.div`
  background-color: ${({ theme }) => theme.box};
  border-radius: 7px;
  overflow: hidden;
  box-shadow: 0px 1px 10px #00000038;
  .header {
    padding: 10px;
    background-color: ${({ theme }) => theme.body};
  }
  .content {
    padding: 10px;
  }
  .file {
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.box};
    box-shadow: 0px 1px 5px #00000050;
    background-color: ${({ theme }) => theme.body};
    .profile {
      border-left: 0.5px solid ${({ theme }) => theme.box};
      border-bottom: 1px solid ${({ theme }) => theme.box};
    }
    .major-details {
      border-bottom: 1px solid ${({ theme }) => theme.box};
    }
  }
`;
